import { useTranslation } from "react-i18next";
import { NeuCard, NeuInput } from "../../components/neu/Neu";

const Row = ({ label, value, bold }) => (
  <div className="flex items-center justify-between gap-4 py-1.5">
    <p className="text-xs text-muted-foreground">{label}</p>
    <p className={`font-mono text-sm ${bold ? "text-lg font-bold text-primary" : "font-semibold"}`}>{value}</p>
  </div>
);

export const PricingCalculator = ({ input, setInput, quotes, currency }) => {
  const { t } = useTranslation();
  const month = quotes.month;
  const year = quotes.year;
  const cur = (currency || "usd").toUpperCase();

  return (
    <NeuCard className="p-6" data-testid="pricing-calculator">
      <div className="grid gap-4 sm:grid-cols-2">
        <div>
          <p className="label-xs mb-2">{t("pricingPage.employees")}</p>
          <NeuInput
            type="number"
            min="1"
            data-testid="calc-employees"
            value={input.employees}
            onChange={(e) => setInput((s) => ({ ...s, employees: e.target.value }))}
          />
          <input
            type="range"
            min="1"
            max="1000"
            value={Math.min(1000, Number(input.employees) || 1)}
            onChange={(e) => setInput((s) => ({ ...s, employees: e.target.value }))}
            className="mt-3 w-full accent-primary"
            data-testid="calc-employees-range"
          />
        </div>
        <div>
          <p className="label-xs mb-2">{t("pricingPage.branches")}</p>
          <NeuInput
            type="number"
            min="1"
            data-testid="calc-branches"
            value={input.branches}
            onChange={(e) => setInput((s) => ({ ...s, branches: e.target.value }))}
          />
          <input
            type="range"
            min="1"
            max="100"
            value={Math.min(100, Number(input.branches) || 1)}
            onChange={(e) => setInput((s) => ({ ...s, branches: e.target.value }))}
            className="mt-3 w-full accent-primary"
            data-testid="calc-branches-range"
          />
        </div>
      </div>

      {month && year ? (
        <div className="mt-6 grid gap-4 sm:grid-cols-2" data-testid="calc-result">
          <NeuCard inset className="p-5">
            <p className="label-xs">{t("signup.monthly")}</p>
            <Row label={t("billing.perEmployee")} value={`${month.price_per_employee} ${cur}`} />
            <Row
              label={t("pricingPage.extraBranches", { included: month.included_branches })}
              value={`${month.branch_cost} ${cur}`}
            />
            <Row label={t("pricingPage.monthlyTotal")} value={`${month.total} ${cur}`} bold />
          </NeuCard>
          <NeuCard inset className="p-5">
            <p className="label-xs">{t("signup.annual")}</p>
            <Row label={t("pricingPage.discount")} value={`${year.annual_discount_percent}%`} />
            <Row label={t("pricingPage.perYear")} value={`${year.total} ${cur}`} bold />
            <p className="mt-2 text-xs text-success" data-testid="calc-saving">
              {t("signup.save")} {(month.total * 12 - year.total).toFixed(2)} {cur}
            </p>
          </NeuCard>
        </div>
      ) : null}
      <p className="mt-4 text-xs text-muted-foreground" data-testid="calc-trial">
        {t("signup.trialNote", { days: month?.trial_days ?? 0 })}
      </p>
    </NeuCard>
  );
};
